var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeavyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 77,
    viewBox: "0 0 95 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H91C93.2091 0 95 1.79086 95 4V73C95 75.2091 93.2091 77 91 77H4C1.79086 77 0 75.2091 0 73V4Z",
    fill: "#020C41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 30.166C50.9518 30.166 53.75 27.3678 53.75 23.916C53.75 20.4642 50.9518 17.666 47.5 17.666C44.0482 17.666 41.25 20.4642 41.25 23.916C41.25 27.3678 44.0482 30.166 47.5 30.166Z",
    stroke: "white",
    strokeWidth: 3.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0413 30.166C35.1398 30.1754 34.2656 30.4769 33.55 31.0253C32.8344 31.5738 32.316 32.3396 32.0726 33.2077L26.8747 52.041C26.7172 52.6506 26.6999 53.2879 26.824 53.9051C26.9482 54.5223 27.2106 55.1033 27.5915 55.6046C27.9725 56.1058 28.462 56.5142 29.0234 56.7991C29.5849 57.0839 30.2035 57.2379 30.833 57.2493H64.1663C64.8094 57.2491 65.4437 57.1 66.0195 56.8138C66.5954 56.5275 67.0972 56.1119 67.4856 55.5994C67.874 55.0869 68.1385 54.4914 68.2584 53.8596C68.3783 53.2278 68.3504 52.5769 68.1768 51.9577L62.9163 33.291C62.6869 32.4023 62.1704 31.6142 61.4471 31.0491C60.7238 30.484 59.8342 30.1736 58.9163 30.166H36.0413Z",
    stroke: "white",
    strokeWidth: 3.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeavyIcon);
export default __webpack_public_path__ + "static/media/heavy-icon.f9ef0b42145fbd6fff42091965d92329.svg";
export { ForwardRef as ReactComponent };